import SvgArrowRight from '@sats-group/icons/16/arrow-right';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import type { Extra as ExtraProps, Selector as Props } from './selector.types';

const Extra: React.FC<ExtraProps> = ({ action, label, title }) => (
  <div className="selector__extra">
    <div className="selector__title">
      <Text size={Text.sizes.small}>{label}</Text>
      <Text size={Text.sizes.large}>{title}</Text>
    </div>
    <Text elementName="div" size={Text.sizes.small}>
      <a className="selector__action" href={action.href}>
        {action.text}
      </a>
    </Text>
  </div>
);

// eslint-disable-next-line react/no-multi-comp
export const Selector: React.FC<Props> = ({ choices, extra }) => (
  <div className="selector">
    {extra.pre.map(entry => (
      <Extra {...entry} key={entry.action.href} />
    ))}
    <div className="selector__main">
      <div className="selector__title">
        <Text>{choices.label}</Text>
        <Text
          elementName="h2"
          size={Text.sizes.headline3}
          tight
          theme={Text.themes.emphasis}
        >
          {choices.title}
        </Text>
      </div>
      <div className="selector__choices">
        {choices.entries.map(entry => (
          <a className="selector__choice" href={entry.href} key={entry.href}>
            <div>
              <Text elementName="span" size={Text.sizes.large}>
                {entry.text}
              </Text>
            </div>
            <div>
              <SvgArrowRight />
            </div>
          </a>
        ))}
      </div>
    </div>
    {extra.post.map(entry => (
      <Extra {...entry} key={entry.action.href} />
    ))}
  </div>
);
